import { render, staticRenderFns } from "./BaseModal.vue?vue&type=template&id=31e38f36"
import script from "./BaseModal.vue?vue&type=script&lang=js"
export * from "./BaseModal.vue?vue&type=script&lang=js"
import style0 from "./BaseModal.vue?vue&type=style&index=0&id=31e38f36&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports